module.exports = __webpack_public_path__ + "img/IMG_20200712_152749.8d0e6295.jpg";